import type { BaseTableRow } from "../../types/components/table.types";
import { getHeaderName } from "../../types/components/table.types";
import { Table } from "./Table";

export interface EnrolledStudentTableRow extends BaseTableRow {
  employeeId: string;
  courseId: string;
  student: string;
  course: string;
}

export class EnrolledStudentsTable extends Table<EnrolledStudentTableRow> {
  static columns = {
    student: {
      field: "student",
      label: "tableColumns.student"
    },
    course: {
      field: "course",
      label: "tableColumns.course"
    }
  };

  static defaultProps = {
    ...Table.defaultProps,
    columns: [
      { type: EnrolledStudentsTable.columns.student },
      { type: EnrolledStudentsTable.columns.course }
    ],
    noRowsMessage: ""
  };

  getRowId(e: EnrolledStudentTableRow) {
    return this.tableId + "_" + e.employeeId + "_" + e.courseId;
  }

  initColumns() {
    const { columns, sortable } = this.props;

    this.columns = [];

    if (!columns) return;

    columns.forEach((c: any) => {
      if (this.hasColumn(c)) {
        if (c.type === EnrolledStudentsTable.columns.student)
          this.columns.push({
            field: "student",
            sortable: sortable,
            headerName: getHeaderName(c, this.props.translate),
            flex: 1,
            filterable: false,
            disableReorder: true
          });

        if (c.type === EnrolledStudentsTable.columns.course)
          this.columns.push({
            field: "course",
            sortable: sortable,
            headerName: getHeaderName(c, this.props.translate),
            flex: 1,
            filterable: false,
            disableReorder: true
          });
      }
    });
  }
}
